import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

export async function getModel({commit}){
    await $http
        .get(`/api/modelo-por-codigo/205`)
        .then(response => {
            if (response.data.data) {
                commit("setModel", response.data.data);
            }
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}


//Obtener todos los registros de la ficha de datos.
export async function fetchListOrderReject({ commit, state, dispatch }) {
  let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);

  await dispatch('getModel')

  let params = {
      filter: state.tableOrderReject.options.search,
      fromDate: state.tableOrderReject.options.fromDate[0],
      toDate: state.tableOrderReject.options.fromDate[1],
      motive_rejected: state.tableOrderReject.options.typeMotive,
      branchoffice_id: state.tableOrderReject.options.sede,
      state_wallet: [state.tableOrderReject.options.state_auth],
      state_backorder: state.tableOrderReject.options.state_backorder,
      detained: true,
      model_id: state.model.id,
      myActivity: state.tableOrderReject.options.myActivity,
      dateFromMyActivity: state.tableOrderReject.options.dateFromMyActivity
  };

  // En caso de que la sede este vacia se agrega una por defecto.
  // if (!params.params.branchoffice_id) {
  //   params.params.branchoffice_id = selected_branchoffice;
  //   state.tableOrderReject.options.sede = selected_branchoffice;
  // }

  state.tableOrderReject.loading = true;

  await $http
    .get(`/api/documentos-retenidos`, {params})
    .then(response => {
      commit("setListOrdersReject", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.response.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });

  state.tableOrderReject.loading = false;
}

export async function changeStatusOrder({ dispatch, commit, state }) {
  var user = JSON.parse(localStorage.user);
  state.dataApproved.user_id_authorizes = user.id;
  // state.tableOrderReject.loading = true;

  await $http
    .put(`/api/pedido/actualizar-estado`, state.dataApproved)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });

      commit(
        "removeDocumentListOrdersRejectById",
        state.dataApproved.document_id
      );
    })
    .catch(error => {
      console.error(error);
      Notification.error({
        title: "Error!",
        message: error.response.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
  // await dispatch("fetchListOrderReject");

  // state.tableOrderReject.loading = false;
}

export async function retainOrderById({ dispatch, commit, state }, id) {
  var user = JSON.parse(localStorage.user);
  state.dataApproved.user_id_authorizes = user.id;
  state.dataApproved.status_id_authorized = 914;

  await $http
    .put(`/api/pedido/${id}/retener`, state.dataApproved)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.response.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
  await dispatch("fetchListOrderReject");
}

// Obtener cartera del cliente
export async function getDocumentProducts(
  { commit, state },
  params
) {
  await $http
    .get(`/api/productos-documento/${params.id}`)
    .then(response => {
      commit("setProducts", {data:response.data.data, index:params.index});
    })
    .catch(error => {
      console.error(error);
      /*Notification.error({
          title: '¡Error!',
          message: error.response.data.message,
          type: 'error',
          duration: 1500,
          customClass: 'notification-box'
      })*/
    });
}


// traer estados backorder
export async function fetchStatesBackOrder({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/050")
        .then(response => {
            commit("setStatesBackOrder", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}



// WEBPACK FOOTER //
// ./src/modules/orders_retained/actions.js